<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="50" width="50" viewBox="0 0 640 480">
        <g fill-rule="evenodd" stroke-width="1pt">
            <path fill="#00319c" d="M0 0h213.333v480H0z"/>
            <path fill="#ffde00" d="M213.333 0h213.333v480H213.333z"/>
            <path fill="#de2110" d="M426.666 0H640v480H426.666z"/>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "Ro"
    }
</script>

<style scoped>

</style>
